import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36bb3b78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-manager" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "卡池卡牌配置", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 添加卡牌 ")
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "稀有度", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "权重", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保底权重", -1))
const _hoisted_9 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_11 = {
  key: 0,
  class: "text-center py-4 text-muted"
}
const _hoisted_12 = {
  class: "d-flex gap-2",
  style: {"width":"100%"}
}
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center mt-1" }
const _hoisted_15 = { class: "text-muted small" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "权重", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small mt-1" }, "建议：普通卡 1000，稀有卡 100，传说卡 10", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _ctx.onAddItem
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.items,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "卡牌",
          "min-width": "180"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_5, [
              (row.card?.image)
                ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    src: row.card.image,
                    fit: "cover",
                    style: {"width":"40px","height":"40px","margin-right":"8px","border-radius":"4px"}
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(row.card?.name || '-'), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "语系",
          width: "80",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.card?.card_language_name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "版本",
          width: "100",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.card?.card_version_name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "稀有度",
          width: "100",
          align: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_el_tooltip, {
              content: "用于保底判断，使用卡牌稀有度",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "ms-1",
                  style: {"vertical-align":"middle"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: _ctx.getRarityTagType(row.card?.rarity),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.effective_level || row.card?.rarity || '-'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "150",
          align: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_el_tooltip, {
              content: "数值越大，抽中概率越高。例如权重 700:200:100，概率约为 70%:20%:10%",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "ms-1",
                  style: {"vertical-align":"middle"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              modelValue: row.weight,
              "onUpdate:modelValue": ($event: any) => ((row.weight) = $event),
              min: 1,
              max: 99999,
              size: "small",
              "controls-position": "right",
              style: {"width":"100%"},
              onChange: ($event: any) => (_ctx.onItemChange(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "150",
          align: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_el_tooltip, {
              content: "能量满时触发保底使用的权重，仅必出等级需要设置",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "ms-1",
                  style: {"vertical-align":"middle"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(({ row }) => [
            (_ctx.isGuaranteedRarity(row))
              ? (_openBlock(), _createBlock(_component_el_input_number, {
                  key: 0,
                  modelValue: row.guaranteed_weight,
                  "onUpdate:modelValue": ($event: any) => ((row.guaranteed_weight) = $event),
                  min: 1,
                  max: 99999,
                  size: "small",
                  "controls-position": "right",
                  style: {"width":"100%"},
                  onChange: ($event: any) => (_ctx.onItemChange(row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "sort",
          label: "排序",
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              modelValue: row.sort,
              "onUpdate:modelValue": ($event: any) => ((row.sort) = $event),
              min: 0,
              size: "small",
              "controls-position": "right",
              style: {"width":"100%"},
              onChange: ($event: any) => (_ctx.onItemChange(row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "动画",
          width: "80",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_switch, {
              modelValue: row.is_animation,
              "onUpdate:modelValue": ($event: any) => ((row.is_animation) = $event),
              onChange: ($event: any) => (_ctx.onItemChange(row)),
              size: "small"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "80",
          align: "center",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.onDeleteItem(row))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.items.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 暂无卡牌，请点击上方\"添加卡牌\"按钮添加 "))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.addDialogVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addDialogVisible) = $event)),
      title: "添加卡牌到卡池",
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addDialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.confirmAddItem,
          loading: _ctx.saving
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.newItem,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "筛选条件" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.cardFilter.language_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardFilter.language_id) = $event)),
                    placeholder: "语系",
                    clearable: "",
                    size: "small",
                    style: {"width":"130px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageStoreOptions, (lang) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: lang.id,
                          label: lang.name,
                          value: lang.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.cardFilter.version_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardFilter.version_id) = $event)),
                    placeholder: "版本",
                    clearable: "",
                    size: "small",
                    style: {"width":"130px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredVersionOptions, (ver) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: ver.id,
                          label: ver.name,
                          value: ver.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.cardFilter.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardFilter.name) = $event)),
                    placeholder: "卡牌名称",
                    clearable: "",
                    size: "small",
                    style: {"flex":"1"}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "选择卡牌",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.newItem.card_ids,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newItem.card_ids) = $event)),
                  placeholder: "请选择卡牌",
                  filterable: "",
                  multiple: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableCards, (card) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: card.id,
                        label: _ctx.formatCardLabel(card),
                        value: card.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            (card.image)
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  src: card.image,
                                  fit: "cover",
                                  style: {"width":"24px","height":"24px","margin-right":"8px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(card.name), 1),
                            (card.card_language_name)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  size: "small",
                                  class: "ms-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(card.card_language_name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (card.card_version_name)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 2,
                                  type: "info",
                                  size: "small",
                                  class: "ms-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(card.card_version_name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_tag, {
                              type: _ctx.getRarityTagType(card.rarity),
                              size: "small",
                              class: "ms-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(card.rarity_display || card.rarity), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, "共 " + _toDisplayString(_ctx.filteredAvailableCards.length) + " 张可选，已选 " + _toDisplayString(_ctx.newItem.card_ids.length) + " 张", 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      link: "",
                      type: "primary",
                      onClick: _ctx.selectAllCards
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      link: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newItem.card_ids = []))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { required: "" }, {
              label: _withCtx(() => [
                _hoisted_18,
                _createVNode(_component_el_tooltip, {
                  content: "数值越大，抽中概率越高",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "ms-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.newItem.weight,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newItem.weight) = $event)),
                  min: 1,
                  max: 99999,
                  "controls-position": "right",
                  style: {"width":"200px"}
                }, null, 8, ["modelValue"]),
                _hoisted_19
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}